import { createAsyncThunk } from "@reduxjs/toolkit";
import type { LicenseRecommendationObject } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchLicenseSubscriptionRecommendations = createAsyncThunk(
	"licenses/fetchLicenseSubscriptionRecommendations",
	apiGet<LicenseRecommendationObject>(
		(authConfig) => authConfig.FUNCTION_API_ENDPOINTS.GET_LICENSE_RECOMMENDATIONS(),
		[SCOPES.FUNCTION_READ],
	),
);
